<!-- 底部 -->
<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <!-- 特色服务 -->
      <div class="service-section">
        <div class="service-item" v-for="(item, index) in services" :key="index">
          <div class="service-icon">
            <el-image :src="item.icon" fit="contain"></el-image>
          </div>
          <div class="service-info">
            <h4>{{ item.title }}</h4>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>

      <!-- 分隔线 -->
      <div class="divider-line"></div>

      <!-- 底部链接 -->
      <div class="link-section">
        <div class="link-group" v-for="(group, gIndex) in linkGroups" :key="gIndex">
          <h5>{{ group.title }}</h5>
          <div class="link-list">
            <a v-for="(link, lIndex) in group.links" :key="lIndex" :href="link.url" target="_blank">
              {{ link.name }}
            </a>
          </div>
        </div>
      </div>

      <!-- 版权信息 -->
      <div class="copyright-section">
        <div class="copyright-content">
          <p class="copyright-text">
            Copyright © 2013 - 现在 扬州博来软件科技有限公司
          </p>
          <p class="copyright-links">
            <a href="https://beian.miit.gov.cn" target="_blank">ICP备案号：苏ICP备14040787号-1</a>
            <span class="divider">|</span>
            <a href="http://www.beian.gov.cn" target="_blank" class="police-link">
              <img :src="require('@/assets/imgs/gaba.png')" alt="公安备案" class="police-icon" />
              苏公网安备 32100302010595号
            </a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      services: [
        {
          icon: require("@/assets/imgs/ytst.png"),
          title: "以图搜款",
          desc: "以图搜款，找货更便捷"
        },
        {
          icon: require("@/assets/imgs/sxtx.png"),
          title: "上新提醒",
          desc: "关注公众号，实时了解档口上新情况"
        },
        {
          icon: require("@/assets/imgs/scdh.png"),
          title: "市场导航",
          desc: "一键导航，精准定位各大市场"
        },
        {
          icon: require("@/assets/imgs/ptdt.png"),
          title: "全平台打通",
          desc: "多平台数据同步，运营更高效"
        }
      ],
      linkGroups: [
        {
          title: "关于我们",
          links: [
            { name: "公司简介", url: "/about" },
            { name: "联系我们", url: "#" },
            { name: "隐私条款", url: "#" },
            { name: "资讯中心", url: "#" }
          ]
        },
        {
          title: "客户服务",
          links: [
            { name: "帮助中心", url: "#" },
            { name: "配送说明", url: "#" },
            { name: "支付方式", url: "#" },
            { name: "售后服务", url: "#" }
          ]
        },
        {
          title: "商家服务",
          links: [
            { name: "商家入驻", url: "#" },
            { name: "企业认证", url: "#" },
            { name: "广告合作", url: "#" },
            { name: "平台规则", url: "#" }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
/* 底部区域 */
.site-footer {
  background: linear-gradient(180deg, #2d3436 0%, #1a1a2e 100%);
  color: #fff;
  margin-top: 40px;
}

.footer-inner {
  width: 1240px;
  margin: 0 auto;
  padding: 40px 0 30px;
}

/* 特色服务区域 */
.service-section {
  display: flex;
  justify-content: space-around;
  padding: 0 20px;
}

.service-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px;
  border-radius: 12px;
  transition: all 0.3s;
}

.service-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.service-icon {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
}

.service-icon .el-image {
  width: 100%;
  height: 100%;
}

.service-info h4 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px;
  color: #fff;
}

.service-info p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  line-height: 1.5;
}

/* 分隔线 */
.divider-line {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  margin: 30px 20px;
}

/* 链接区域 */
.link-section {
  display: flex;
  justify-content: center;
  gap: 60px;
  padding: 0 20px;
}

.link-group h5 {
  font-size: 15px;
  font-weight: 600;
  margin: 0 0 15px;
  color: #fff;
}

.link-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.link-list a {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.3s;
}

.link-list a:hover {
  color: #ff6b6b;
}

/* 版权区域 */
.copyright-section {
  margin-top: 40px;
  padding-top: 25px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.copyright-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.copyright-text {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.copyright-links {
  font-size: 12px;
  margin: 0;
}

.copyright-links a {
  color: rgba(255, 255, 255, 0.5);
  transition: color 0.3s;
}

.copyright-links a:hover {
  color: #ff6b6b;
}

.copyright-links .divider {
  margin: 0 10px;
  color: rgba(255, 255, 255, 0.3);
}

.police-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.police-icon {
  width: 16px;
  height: 16px;
}
</style>
